export default "__VITE_PUBLIC_ASSET__39963bb9__"